@if (showLdr) {
<ds-loading></ds-loading>
}
<div class="driver-slider">
  <!-- Header Section -->
  <div class="slider-header">
    <div class="header-content">
      <!-- Driver Profile -->
      <div class="driver-profile">
        <div class="avatar-wrapper">
          <img
            src="../../../../../assets/images/driver.png"
            alt="Driver"
            class="avatar-img"
          />
          <span
            class="status-dot"
            [class.online]="drvrDtls && drvrDtls[0]?.asrtglblId == '1'"
          ></span>
        </div>
        <div class="profile-details">
          <h1 class="driver-name">
            {{ crwDtls.crw_nm || "Driver Name" }}
            <span
              class="own-hired-badge"
              [ngClass]="{
                'own-badge': crwDtls.own_in == 1,
                'hired-badge': crwDtls.own_in == 2,
                'apcos-badge': crwDtls.own_in == 3
              }"
            >
              {{
                crwDtls.own_in == 1
                  ? "Own"
                  : crwDtls.own_in == 2
                  ? "Hired"
                  : crwDtls.own_in == 3
                  ? "APCOS"
                  : ""
              }}
            </span>
          </h1>
          <div class="meta-info">
            <span class="meta-item">
              <i nz-icon nzType="phone" nzTheme="outline"></i>
              {{
                !crwDtls.crw_ph || crwDtls.crw_ph == 0
                  ? "Not Provided"
                  : crwDtls.crw_ph
              }}
            </span>
            <span class="meta-item">
              <i nz-icon nzType="idcard" nzTheme="outline"></i>
              {{
                !crwDtls.crw_lcnse_nu || crwDtls.crw_lcnse_nu == "undefined"
                  ? "Not Provided"
                  : crwDtls.crw_lcnse_nu
              }}
            </span>
          </div>
          @if (crwDtls.asrt_nm) {
          <div class="vehicle-info">
            <i nz-icon nzType="car" nzTheme="outline"></i>
            <span>{{ crwDtls.asrt_nm }}</span>
            @if (crwDtls.asrt_sts_nm) {
            <span
              class="vehicle-badge"
              [ngStyle]="{
                'background-color': crwDtls.bg_clr_cd,
                color: crwDtls.clr_cd
              }"
            >
              {{ crwDtls.asrt_sts_nm }}
            </span>
            }
          </div>
          } @if (clntDtls[0].clnt_id==7 && crwDtls.svm_nm) {
          <div class="sachivalayam-info">
            <i nz-icon nzType="environment" nzTheme="outline"></i>
            <span>{{ crwDtls.svm_nm }}</span>
          </div>
          }
        </div>
      </div>

      <!-- Attendance Section with Pie Chart -->
      <div class="attendance-section">
        <div class="attendance-chart">
          <nz-progress
            [nzPercent]="attendanceData.percentage"
            [nzStrokeColor]="
              attendanceData.percentage >= 80
                ? '#10b981'
                : attendanceData.percentage >= 50
                ? '#f59e0b'
                : '#ef4444'
            "
            [nzShowInfo]="true"
            nzType="circle"
            [nzWidth]="80"
            [nzStrokeWidth]="10"
          >
          </nz-progress>
          <div class="attendance-label">Attendance</div>
        </div>
        <div class="attendance-stats">
          <div class="att-stat present">
            <span class="att-count">{{ attendanceData.daysPresent }}</span>
            <span class="att-text">Present</span>
          </div>
          <div class="att-stat absent">
            <span class="att-count">{{
              attendanceData.totalDays - attendanceData.daysPresent
            }}</span>
            <span class="att-text">Absent</span>
          </div>
        </div>
        <!-- Attendance Days (Last 7 Days) -->
        @if (attendanceDays && attendanceDays.length > 0) {
        <div class="attendance-days">
          @for (day of attendanceDays; track day; let i = $index) {
          <div
            class="day-item"
            [class.present]="day.operated === 1"
            [class.absent]="day.operated === 0"
            [nz-tooltip]="
              day.dt + ' - ' + (day.operated === 1 ? 'Present' : 'Absent')
            "
          >
            <span class="day-date">{{ getAttendanceDate(i) }}</span>
            <i
              nz-icon
              [nzType]="day.operated === 1 ? 'check-circle' : 'close-circle'"
              nzTheme="fill"
            ></i>
          </div>
          }
        </div>
        }
      </div>

      <!-- Stats -->
      <div class="header-stats">
        <div class="stat-box">
          @if (drvrTtlDtls && drvrTtlDtls.length>0) {
          <div class="stat-value">
            {{ drvrTtlDtls[1][0].trp_cnt || "0" }}
          </div>
          } @if (!drvrTtlDtls || drvrTtlDtls.length<=0) {
          <div class="stat-value">0</div>
          }
          <div class="stat-label">Today's Trips</div>
        </div>
        <div class="stat-box">
          @if (drvrTtlDtls && drvrTtlDtls.length>0) {
          <div class="stat-value">
            {{ drvrTtlDtls[0][0].tot_dst || "0" }}
            <small>km</small>
          </div>
          } @if (!drvrTtlDtls || drvrTtlDtls.length<=0) {
          <div class="stat-value">0 <small>km</small></div>
          }
          <div class="stat-label">Distance</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Map & Heatmap Side by Side -->
  <div class="map-heatmap-grid">
    <!-- Map Card -->
    <div class="card map-card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #6366f1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
            ></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
            ></path>
          </svg>
          <h3>Current Location</h3>
        </div>
      </div>
      <div class="card-body no-padding">
        <div id="driverMap"></div>
      </div>
    </div>

    <!-- Heat Chart Card -->
    <div class="card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #6366f1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
            ></path>
          </svg>
          <h3>24/7 Distance Coverage</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        <div id="hepachartdiv"></div>
      </div>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="charts-section">
    <div class="card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #8b5cf6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
            ></path>
          </svg>
          <h3>Distance Travelled</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        <div id="lastSevenDaysDistanceChart"></div>
        @if (drvrDtls && drvrDtls.length <= 0) {
        <div class="empty-state">
          <i nz-icon nzType="line-chart" nzTheme="outline"></i>
          <p>No distance data available</p>
        </div>
        }
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #10b981"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
          <h3>Trips Completed</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        <div id="lastSevenDaysChart"></div>
        @if (drvrDtls && drvrDtls.length <= 0) {
        <div class="empty-state">
          <i nz-icon nzType="bar-chart" nzTheme="outline"></i>
          <p>No trips data available</p>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Tables Section -->
  <div class="tables-section">
    <div class="card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #6366f1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
            ></path>
          </svg>
          <h3>Operational Details</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        @if (drvrOptnlDtls && drvrOptnlDtls.length>0) {
        <div class="table-wrapper">
          <table class="data-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Vehicle</th>
                <th>Category</th>
                <th>Hours</th>
                <th>Distance</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (o of drvrOptnlDtls; track o) {
              <tr>
                <td>{{ o.dt }}</td>
                <td class="text-primary">{{ o.asrt_nm }}</td>
                <td>{{ o.asrt_ctgry_nm }}</td>
                <td>{{ o.oprtn_hrs_ct }}</td>
                <td>{{ o.dst }} km</td>
                <td>
                  <span
                    class="status-pill"
                    [class.success]="o.operated == 1"
                    [class.warning]="o.operated == 0"
                  >
                    {{ o.operated == 1 ? "Operated" : "Not Operated" }}
                  </span>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @if (oprtnlhrsMsg) {
        <div class="empty-state">
          <i nz-icon nzType="file-text" nzTheme="outline"></i>
          <p>{{ oprtnlhrsMsg }}</p>
        </div>
        }
      </div>
    </div>

    <div class="card">
      <div class="card-header warning">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #f59e0b"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            ></path>
          </svg>
          <h3>Speed Violations</h3>
        </div>
        <span class="badge warning">Last 7 Days</span>
      </div>
      <div class="card-body">
        @if (drvrSpdDtls && drvrSpdDtls.length>0) {
        <div class="table-wrapper">
          <table class="data-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Vehicle</th>
                <th>Category</th>
                <th>Speed</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              @for (t of drvrSpdDtls; track t) {
              <tr>
                <td>{{ t.dt }}</td>
                <td class="text-primary">{{ t.asrt_nm }}</td>
                <td>{{ t.asrt_ctgry_nm }}</td>
                <td class="text-danger font-medium">{{ t.speed }} km/h</td>
                <td>
                  <a
                    class="link-btn"
                    href="https://www.google.com/maps/search/?api=1&query={{
                      t.r_lat
                    }},{{ t.r_lng }}"
                    target="_blank"
                  >
                    <i nz-icon nzType="environment" nzTheme="outline"></i>
                    View
                  </a>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @if (fuelDtaMsg) {
        <div class="empty-state success">
          <i nz-icon nzType="safety-certificate" nzTheme="outline"></i>
          <p>{{ fuelDtaMsg }}</p>
        </div>
        }
      </div>
    </div>
  </div>
</div>
